import { Stack } from "@mui/material";
import * as React from "react";
import Icon from "src/components/icon";
import gitlabIcon from "src/assets/icons/gitlab-int";
import githubIcon from "src/assets/icons/github-int";
import { IntegrationCategories } from "src/components/template/constants";
import jiraIcon from "src/assets/icons/jira-int";
import notionIcon from "src/assets/icons/notion-int";
import slackIcon from "src/assets/icons/slack-int";
import googleWorkspaceIcon from "src/assets/icons/google-workspace-int";
import microsoftCalendarIcon from "src/assets/icons/microsoft-calendar-int";
import msTeamsIcon from "src/assets/icons/teams-nav-icon";
import Link from "src/components/link";

const TemplateNoIntegration = ({
    integrationCategories,
}: {
    integrationCategories: IntegrationCategories[];
}) => {
    const icons: { [key: string]: string } = {};
    if (integrationCategories.includes(IntegrationCategories.git)) {
        icons.gitlab = gitlabIcon;
        icons.github = githubIcon;
    } else if (integrationCategories.includes(IntegrationCategories.pm)) {
        icons.jira = jiraIcon;
        icons.notion = notionIcon;
    } else if (integrationCategories.includes(IntegrationCategories.collaboration)) {
        icons.slack = slackIcon;
        icons.google = googleWorkspaceIcon;
        icons.ms = microsoftCalendarIcon;
    } else if (integrationCategories.includes(IntegrationCategories.slack)) {
        icons.slack = slackIcon;
    } else if (integrationCategories.includes(IntegrationCategories.chat)) {
        icons.slack = slackIcon;
        icons.msTeams = msTeamsIcon;
    } else if (integrationCategories.includes(IntegrationCategories.meetings)) {
        icons.google = googleWorkspaceIcon;
        icons.ms = microsoftCalendarIcon;
    } else {
        icons.gitlab = gitlabIcon;
        icons.github = githubIcon;
        icons.jira = jiraIcon;
        icons.notion = notionIcon;
        icons.slack = slackIcon;
        icons.google = googleWorkspaceIcon;
        icons.ms = microsoftCalendarIcon;
    }
    return (
        <Stack
            direction="column"
            justifyContent="center"
            alignItems="center"
            style={{ height: "100%" }}
        >
            <Stack direction="row" spacing={2}>
                {Object.keys(icons).map((key) => (
                    <Icon
                        key={key}
                        svg={icons[key]}
                        fill="palette.background.noIntegrationIcons"
                        height="42px"
                        width="42px"
                        pointer={false}
                    />
                ))}
            </Stack>
            <span
                style={{ opacity: "0.6", fontSize: "1rem", paddingTop: "10px", fontWeight: "300" }}
            >
                <Link to="/integrations">Integrate</Link> to get data
            </span>
        </Stack>
    );
};

export default TemplateNoIntegration;
